let Promise = require('bluebird');
let Vue = require('vue');

module.exports = () => new Promise((resolve, reject) => {
    Vue.component("customers_count", {
        template: `
            <div class="grid-item col-xs-12 col-sm-6 col-md-6 col-lg-3">
                <a class="dashboard-stat dashboard-stat-light widget-clientes" v-bind:href="'/customers' | url">
                    <div class="visual">
                        <i class="icon-users"></i>
                    </div>
                    <div class="details">
                        <div class="number">
                             <span class="mynumber">{{data.info.count}}</span>/{{data.info.total}}
                        </div>
                        <div class="desc">
                             Meus clientes / Totais
                        </div>
                    </div>
                    </a>
            </div>
        `,
        props: ["alias", "data"]
    });

    resolve();
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/widgets/customers_count.js